<template>
  <div class="flex flex-col w-12 bg-white pin-l shadow flex-no-shrink flex-no-grow z-10">
    <div v-if="isGeneralDoctor() && role !== 'specialistDoctor'" title="Chat" @click="selectMenu('Chat')" v-bind:class="[activeMiniMenu==='Chat' ? 'border-l-4 border-solid border-blue' : 'opacity-50']"  class="cursor-pointer w-12 h-12 flex flex-row justify-center flex-no-shrink">
        <img class="h-6 w-6 self-center -ml-1" src="../assets/chat.png" alt="Chat">
    </div>
    <div v-if="!is_Admin" title="Search Patient" @click="selectMenu('OfflineConsults')" v-bind:class="[activeMiniMenu==='OfflineConsults' ? 'border-l-4 border-solid border-blue' : 'opacity-50']" class="cursor-pointer w-12 h-12 flex flex-row justify-center flex-no-shrink">
        <img class="h-6 w-6 self-center" src="../assets/profile.png" alt="Search Patient">
    </div>
    <div v-if="isGeneralDoctor()" title="Appointments" @click="selectMenu('Appointments')" v-bind:class="[activeMiniMenu==='Appointments' ? 'border-l-4 border-solid border-blue' : 'opacity-50']"  class="cursor-pointer w-12 h-12 flex flex-row justify-center flex-no-shrink">
        <img class="h-6 w-6 self-center" src="../assets/schedule.png" alt="Appointments">
    </div>
    <div v-if="role === 'externalAdmin'" title="Appointments" @click="selectMenu('Appointments')" v-bind:class="[activeAdminMiniMenu==='Appointments' ? 'border-l-4 border-solid border-blue' : 'opacity-50']"  class="cursor-pointer w-12 h-12 flex flex-row justify-center flex-no-shrink">
        <img class="h-6 w-6 self-center" src="../assets/schedule.png" alt="Appointments">
    </div>
    <div v-if="isAdminDoctor() && role !== 'externalAdmin'" title="Doctors" @click="selectMenu('DoctorMain')" v-bind:class="[activeAdminMiniMenu==='DoctorMain' ? 'border-l-4 border-solid border-blue' : 'opacity-50']"  class="cursor-pointer w-12 h-12 flex flex-row justify-center flex-no-shrink">
        <img class="h-6 w-6 self-center -ml-1" src="../assets/chat.png" alt="Doctors">
    </div>
    <div v-if="isAdminDoctor()" title="Upload Doctor Roster" @click="selectMenu('UploadDoctorRoster')" v-bind:class="[activeAdminMiniMenu==='UploadDoctorRoster' ? 'border-l-4 border-solid border-blue' : 'opacity-50']"  class="cursor-pointer w-12 h-12 flex flex-row justify-center flex-no-shrink">
      <img class="h-6 w-6 self-center" style="color: blue" src="../assets/upload_csv.png" alt="Upload a File">
    </div>
    <div  v-if="isAdminDoctor()" title="Schedule of Doctor" @click="selectMenu('DoctorSchedule')" v-bind:class="[activeAdminMiniMenu==='DoctorSchedule' ? 'border-l-4 border-solid border-blue' : 'opacity-50']"  class="cursor-pointer w-12 h-12 flex flex-row justify-center flex-no-shrink">
      <img class="h-6 w-6 self-center" style="color: blue" src="../assets/call-calendar-dark.png" alt="Schedule of Doctor">
    </div>
    <div  v-if="isAdminDoctor() && role !== 'externalAdmin'" title="Chat availability of Doctor" @click="selectMenu('DoctorChatAvailability')" v-bind:class="[activeAdminMiniMenu==='DoctorChatAvailability' ? 'border-l-4 border-solid border-blue' : 'opacity-50']"  class="cursor-pointer w-12 h-12 flex flex-row justify-center flex-no-shrink">
      <img class="h-6 w-6 self-center" style="color: blue" src="../assets/doctorSchedule.svg" alt="Chat availability of Doctor">
    </div>
    <div v-if="isGeneralDoctor() && role !== 'specialistDoctor'" title="Schedule of Doctor" @click="selectMenu('DoctorSchedule')" v-bind:class="[activeMiniMenu==='DoctorSchedule' ? 'border-l-4 border-solid border-blue' : 'opacity-50']"  class="cursor-pointer w-12 h-12 flex flex-row justify-center flex-no-shrink">
      <img class="h-6 w-6 self-center" style="color: blue" src="../assets/doctorSchedule.svg" alt="Schedule of Doctor">
    </div>
    <div v-if="!isCompanyDoctor && !['specialistDoctor', 'externalAdmin'].includes(role)" title="COVID-19" @click="selectMenu('COVID19')" v-bind:class="[activeMiniMenu==='COVID19' ? 'border-l-4 border-solid border-blue' : 'opacity-50']"  class="cursor-pointer w-12 h-12 flex flex-row justify-center flex-no-shrink">
      <img class="h-6 w-6 self-center" style="color: blue" src="../assets/coronavirus.svg" alt="COVID-19">
    </div>
    <UnsavedChangesModal v-if="showSaveReminder" @close='closeModal'/>
  </div>
</template>

<script>
import {mapState, mapGetters} from 'vuex'
import UnsavedChangesModal from '@/components/common/modals/UnsavedChanges'
export default {
  components: {
    UnsavedChangesModal
  },
  data () {
    return {
      showSaveReminder: false
    }
  },
  computed: {
    ...mapState({
      activeMiniMenu: state => state.configuration.activeMiniMenu,
      activeAdminMiniMenu: state => state.configuration.activeAdminMiniMenu,
      editTextField: state => state.textField.inEdit,
      isCompanyDoctor: state => state.configuration.isCompanyDoctor
    }),
    ...mapGetters({
      role: 'configuration/getRole'
    }),
    is_Admin () {
      if (sessionStorage.getItem('isAdmin')) {
        return true
      }
      return false
    }
  },
  methods: {
    selectMenu: function (menu) {
      if (this.is_Admin) {
        this.$emit('getAdminMenu', menu)
        this.$store.dispatch('configuration/setActiveAdminMiniMenu', menu)
        return
      }
      if (this.editTextField) {
        this.showSaveReminder = true
        return
      }
      this.$store.dispatch('configuration/setActiveMiniMenu', menu)
    },
    closeModal: function (params) {
      this.showSaveReminder = false
    },
    isGeneralDoctor: function () {
      return !this.is_Admin && !this.isCompanyDoctor
    },
    isAdminDoctor: function () {
      return this.is_Admin && !this.isCompanyDoctor
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/MiniMenu.vue